module.exports = __webpack_public_path__ + "img/dz.7d7cc16f.svg";